import Vue from 'vue'
import VueRouter from 'vue-router'
import { UserApi } from '@/apis/index.js'
import { Toast } from 'vant'
import store from '@/store'
import payRoutes from './module/payment'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import('../views/login/index')
  },
  {
    path: '/bind',
    component: () => import('../others/bind')
  },
  {
    path: '/workbenches',
    component: () => import('../views/workbenches'),
    children: [
      {
        path: '/home',
        component: () => import('../views/home/index')
      },
      {
        path: '/home/ranking',
        component: () => import('../views/home/ranking/index.vue')
      },
      /** 设备管理 **/
      {
        path: '/machine',
        component: () => import('@/views/machine/index')
      },
      {
        path: '/machine/out-stock',
        component: () => import('@/views/machine/out-stock')
      },
      {
        path: '/machine/out-stock-detail',
        component: () => import('@/views/machine/out-stock-detail')
      },
      {
        path: '/machine/add',
        component: () => import('@/views/machine/add')
      },
      {
        path: '/machine/update',
        component: () => import('@/views/machine/update')
      },
      {
        path: '/machine/detail',
        component: () => import('@/views/machine/detail')
      },
      {
        path: '/machine/distribution',
        // component: () => import('@/views/machine/distribution')
        component: () => import('@/views/machine/distribution/index')
      },
      {
        path: '/machine/track-set',
        // component: () => import('../views/machine/freight-track-set')
        component: () => import('@/views/machine/track-set/list.vue')
      },
      /** **/
      {
        path: '/order',
        component: () => import('../views/order/index')
      },
      {
        path: '/replenishment',
        component: () => import('../views/replenishment/index')
      },
      {
        path: '/user',
        component: () => import('../views/user/index')
      },
      {
        path: '/user/index',
        component: () => import('../views/user/index.vue')
      },
      {
        path: '/user/notice',
        component: () => import('../views/user/notice.vue')
      },
      {
        path: '/user/customer',
        component: () => import('../views/user/customer.vue')
      },
      {
        path: '/user/update-password',
        component: () => import('../views/user/update-password.vue')
      },
      {
        path: '/user/renew',
        component: () => import('../views/user/renew.vue')
      },
      {
        path: '/user/renewal-support',
        component: () => import('../views/user/renewal-support')
      },
      // {
      //   path: '/user/recharge',
      //   component: () => import('../views/user/recharge')
      // },
      {
        path: '/order/detail',
        component: () => import('../views/order/detail')
      },
      {
        path: '/order/refund',
        component: () => import('../views/order/refund-detail')
      },
      {
        path: '/order/third',
        component: () => import('../views/order/third-party')
      },
      {
        path: '/replenishment/replenishment',
        component: () => import('../views/replenishment/replenishment')
      },
      {
        path: '/product/index',
        component: () => import('../views/product/index')
      },
      {
        path: '/product/update',
        component: () => import('../views/product/update')
      },
      {
        path: '/product/warehouse',
        component: () => import('../views/product/warehouse')
      },
      {
        path: '/product/add',
        component: () => import('../views/product/add')
      },
      {
        path: '/product/classification',
        component: () => import('../views/product/classification')
      },
      {
        path: '/product/shipping-record',
        component: () => import('../views/product/shipping-record')
      },
      {
        path: '/statistics/operations',
        // component: () => import('../views/statistics/operations.vue')
        component: () => import('../views/statistics/income.vue')
      },
      {
        path: '/bill',
        name: 'BillLogs',
        component: () => import('@/views/bill/index.vue')
      },
      {
        path: '/bill-detail',
        name: 'BillDetail',
        component: () => import('@/views/bill/detail.vue')
      },
      {
        path: '/complaint',
        name: 'Complaint',
        component: () => import('@/views/complaint/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  //base: process.env.BASE_URL,
  routes: [...routes, payRoutes]
})
/*
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    let token = localStorage.getItem('token')
    if (token) {
        let checkedKeys = localStorage.getItem('checkedKeys')
        if (checkedKeys) {
          next()
        } else {
          if (+localStorage.getItem('userId') === 1) {
            let sysMenuVosData = localStorage.getItem('sysMenuVosData')
            if (sysMenuVosData) {
              let sysMenuVos = JSON.parse(sysMenuVosData)
              let menuId = sysMenuVos.map((ev) => {
                return ev.menuId
              })
              localStorage.setItem('checkedKeys', JSON.stringify(menuId))
            } else {

            }
            next()
          } else {
            let params = {
              id: localStorage.getItem('userId')
            }
            UserApi.userMenuTreeselect(params).then((res) => {
              if (res.code === 200) {
                let checkedKeys = res.checkedKeys
                console.log(checkedKeys)
                localStorage.setItem('checkedKeys', JSON.stringify(checkedKeys))
                router.app.$options.store.state.sysMenuVos = checkedKeys
                console.log(router.app.$options.store.state)
                next()
              } else {
                Toast('获取权限失败')
              }
            }).catch(() => {
              Toast('获取权限失败')
            })
          }
      }
    } else {
      next('/login')
    }
  }
})
*/

export default router
